import React, { useState } from "react";
import { AddIconColor, AddIconWhite } from "../../../../assets/images";
import { BomOutputGoodsType } from "../../../../commonTypes/invoiceGenerationTypes";
import { BomOutputType } from "../../../../commonTypes/billOfMaterial";

type AppProps = {
  addMoreData: (type: string) => void;
  type: string;
  data?: BomOutputType[] | [];
};

const BomAddMore = ({ addMoreData, type, data }: AppProps) => {
  const [buttonColor, setButtonColor] = useState<boolean>(false);
  return (
    <tr className="addMore">
      <td colSpan={2}>
        <button
          onMouseOver={() => setButtonColor(true)}
          onMouseOut={() => setButtonColor(false)}
          className="btn btn-sm btn-outline fixed-button"
          onClick={() => addMoreData(type)}
        >
          <img
            className="btn-outline"
            src={buttonColor ? AddIconWhite : AddIconColor}
            alt="add_icon"
          />
          Add
        </button>
      </td>
    </tr>
  );
};

export default BomAddMore;
